<template>
    <div>

        <config-main-title>
            Formas de Pagamento
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluirForma()">
                    Incluir Forma de Pagamento
                </button>
            </div>
        </div>

        <az-empty-state v-if="!lista_exibicao.length" />

        <div v-if="lista_exibicao.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista_exibicao" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <button type="button" class="btn btn-link card-link p-0" v-if="dado.id_forma_pagamento == 2 || dado.id_forma_pagamento == 3 || dado.search == 'PIX'"
                                data-toggle="collapse" :href="'.collapse-' + id">
                                <span class="h5 card-link mb-0 mr-3">
                                    {{ dado.search }}
                                </span>
                            </button>
                            <span class="h5 mb-0" v-else-if="dado.id_forma_pagamento > 0"> 
                                <a href="#" @click.prevent="editarForma(dado.forma_pagamento)" class="card-link">
                                    {{ dado.search }}
                                </a>
                            </span>
                            <span class="h5 mb-0" v-else> 
                                {{ dado.search }}
                            </span>

                            <span v-if="dado.forma_pagamento && dado.forma_pagamento.fl_repasse_devol" title="Recebimento direto pelo profissional.">
                                <i class="fa-solid fa-circle-dollar-to-slot ml-2"></i>
                            </span>

                            <span v-if="dado.forma_pagamento && dado.forma_pagamento.fl_block_recibo" title="Não imprimmir recibo.">
                                <i class="fa-solid fa-file-circle-xmark ml-2"></i>
                            </span>
                        </span>
                        <span class="d-flex">

                            <div class="collapse multi-collapse" :class="'collapse-' + id">
                                <a href="#" @click.prevent="editarForma(dado.forma_pagamento)" class="card-link">
                                    <i class="fas fa-edit"></i>
                                </a>
                                <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Bandeira"
                                    @click.prevent="incluirBandeira(dado)">
                                    <i class="fas fa-plus text-success"></i>
                                </a>
                            </div>
                            <div class="custom-control custom-switch ml-3" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <div class="h5 ml-3" v-else>
                                <span class="badge badge-secondary">#{{ dado.id_forma_pagamento }}</span>
                            </div>

                            <button type="button" class="btn btn-sm btn-outline-secondary ml-3" @click="acessos(dado)" v-if="dado.forma_pagamento && dado.forma_pagamento.acessos">
                                <i class="fas fa-user-lock mr-2"></i>
                                {{ dado.forma_pagamento.acessos.length }}
                            </button>
                        </span>
                    </div>
                    <div class="collapse multi-collapse m-3" :class="'collapse-' + id" :id="'collapse-' + id" v-if="dado.forma_pagamento.bandeira_cartaos">

                        <div class="list-group mb-3 az-anime-surgir mb-3">
                            <li class="list-group-item d-flex justify-content-between" v-for="(bandeira, ib) in bandeiras_ativas(dado.forma_pagamento.bandeira_cartaos)" :key="ib">
                                <span>
                                    <a href="#" @click.prevent="editar(bandeira)" class="h5 card-link mb-0 mr-3">
                                        {{ bandeira.search }}
                                    </a>

                                    <span v-if="bandeira.filtros && bandeira.filtros.length" class="badge badge-secondary mr-3">
                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                        {{ bandeira.filtros.length }}
                                    </span>

                                    <span v-if="bandeira.filtros && bandeira.filtros.length == 1 && bandeira.filtros[0].model" class="small text-muted mr-3">
                                        {{ bandeira.filtros[0].model.search }}
                                    </span>
                                </span>
                                <span>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" 
                                            :id="'bandeira-' + id + '-' + ib" 
                                            v-model="bandeira.por_unidade.fl_ativo"
                                            @change="toggleBandeira(bandeira.por_unidade)">
                                        <label class="custom-control-label" :for="'bandeira-' + id + '-' + ib"></label>
                                    </div>
                                </span>
                            </li>
                        </div>

                    </div>
                </li>
            </div>

        </div>

        <pre v-if="false">{{ dados }}</pre>

        <!-- Modal Cadastro Forma de Pagamento-->
        <div class="modal fade" id="modelFormaDePagamento" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Forma de Pagamento
                            <span class="badge badge-secondary ml-2">
                                {{ edicao.id_forma_pagamento ? '#' + edicao.id_forma_pagamento : 'Nova' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :edicao="!edicao.id_forma_pagamento || edicao.id_forma_pagamento > 4"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.st_forma_pagamento" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Recebimento Direto pelo Profissional"
                                    :validate="validate"
                                    v-model="edicao.fl_repasse_devol" />

                                <div class="alert alert-info mb-3" v-if="edicao.fl_repasse_devol">
                                    Ao marcar essa opção, indica-se que o pagamento particular é feito diretamente ao profissional, fazendo com que o lançamento no repasse seja de devolução do valor da clínica.
                                </div>
                            </div>

                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Não Imprimir Recibo"
                                    :validate="validate"
                                    v-model="edicao.fl_block_recibo" />
                            </div>

                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Não Incluir no Repasse"
                                    :validate="validate"
                                    v-model="edicao.fl_block_repasse" />
                            </div>

                            <div class="col col-12" v-if="contself">
                                <az-input
                                    type="checkbox-group"
                                    label="Não enviar valores para o Contself"
                                    :validate="validate"
                                    v-model="edicao.fl_nao_enviar_contself" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="notafiscalFormaPagamento">
                            <div class="col col-12">
                                <az-input
                                    label="Emitir a NF por Outra Unidade:"
                                    type="select"
                                    placeholder="Não..."
                                    :optionsList="$util.unidades_com_tags(false, false)"
                                    optionsData="id_unidade_operacao"
                                    v-model="edicao.id_unidade_operacao_nf" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    label="Id Externo"
                                    :validate="validate"
                                    v-model="edicao.st_id_externo" />
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="formaPagamento" :id="edicao.id_forma_pagamento" v-if="edicao.id_forma_pagamento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_forma_pagamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bandeira -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item.tipo_cartao_exibir == 'PIX' ? 'PIX' : 'Cartão de ' + item.tipo_cartao_exibir }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Nome"
                                    required
                                    :validate="validate"
                                    v-model="item.st_bandeira_cartao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Valor Parcela Mínima"
                                    type="money"
                                    :validate="validate"
                                    v-model="item.por_unidade.dc_valor_min_parcela" />
                            </div>
                        </div>
                        <div class="row" v-if="item.tipo_cartao_exibir != 'PIX'">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Prazo de Recebimento (em dias)"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.por_unidade.in_prazo_recebimento" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Prazo de Recebimento Quando Parcelado (em dias)"
                                    placeholder="O mesmo..."
                                    type="number"
                                    v-if="item.por_unidade.in_maximo_parcelas > 1"
                                    v-model="item.por_unidade.in_prazo_recebimento_parcelado" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6" v-if="item.ch_tipo == 'C'">
                                <az-input 
                                    label="Máximo de Parcelas"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.por_unidade.in_maximo_parcelas" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Taxa à Vista (%)"
                                    type="money"
                                    :validate="validate"
                                    v-model="item.por_unidade.dc_taxa" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6" v-if="item.ch_tipo == 'C' || item.ch_tipo == 'D'">
                                <az-input
                                    sizing="sm"
                                    label="Conta para recebimento"
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="contas.index"
                                    optionsName="contas.index.ativas"
                                    optionsData="id_conta"
                                    optionsDisplay="search"
                                    :optionsParm="{ ativas: true }"
                                    v-model="item.por_unidade.id_conta" />
                            </div>
                        </div>

                        <div v-if="item.por_unidade.in_maximo_parcelas > 1" class="mt-3">

                            <az-input   
                                type="checkbox-group"
                                label="Recebimento das Parcelas Antecipado"
                                v-model="item.por_unidade.fl_receber_parcelas_antecipadas" />

                            <az-sub-title title="Parcelas e Taxas" />
                            <button type="button" class="btn btn-outline-primary btn-sm mt-3" @click="incluirParcelaTaxa()" v-if="listaParcelas && listaParcelas.length == 0">
                                Incluir Taxa
                            </button>
                            <div class="row" v-for="(parc, iparc) in listaParcelas" :key="iparc">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="De"
                                        type="number"
                                        :edicao="true"
                                        min="2"
                                        :max="item.por_unidade.in_maximo_parcelas"
                                        @change.native="ajustarParcelas(listaParcelas, iparc, 'min')"
                                        v-model="parc.in_parcela_min" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Até"
                                        type="number"
                                        min="2"
                                        :max="item.por_unidade.in_maximo_parcelas"
                                        v-model="parc.in_parcela_max" 
                                        @change.native="ajustarParcelas(listaParcelas, iparc, 'max')"
                                        v-if="iparc < listaParcelas.length - 1" />
                                    <az-input
                                        label="Até"
                                        :edicao="false"
                                        :value="parseInt(item.por_unidade.in_maximo_parcelas) > parseInt(parc.in_parcela_min) ? 'ou mais parcelas' : '-'"
                                        v-else />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Taxa (%)"
                                        type="money"
                                        :icon="parseInt(item.por_unidade.in_maximo_parcelas) > parseInt(parc.in_parcela_min) ? 'fas fa-plus' : ''"
                                        buttonColor="outline-success"
                                        :buttonIcon="true"
                                        buttonText="fas fa-plus"
                                        @clickButton="incluirParcelaTaxa ()"
                                        v-model="parc.dc_taxa"
                                        v-if="iparc == listaParcelas.length - 1" />
                                    <az-input
                                        label="Taxa (%)"
                                        type="money"
                                        icon="fas fa-minus"
                                        buttonColor="outline-danger"
                                        :buttonIcon="true"
                                        buttonText="fas fa-minus"
                                        @clickButton="parc.excluido = true"
                                        v-model="parc.dc_taxa"
                                        v-else />
                                </div>
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <pre v-if="1 == 0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="bandeiraCartao" :id="item.id_bandeira_cartao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizarBandeira ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            bandeiras: null,
            search: "", 
            novoProcedimento: null, 
            edicao: null, 
            viewMode: "A",
            notafiscalFormaPagamento: false,
            contself: false,
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput,
        AzSubTitle, 
        AzSubmit, 
        AzAuditLogButton, 
        AzEmptyState,
        FiltroModel, 
        EdicaoAcessos, 
    },

    computed: { 
        listaParcelas: function () { 
            return this.item.por_unidade.bandeira_cartao_parcelas.filter(item => !item.excluido);
        },

        lista_exibicao: function () { 
            if ( !this.dados )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                .filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_opcoes_filtro: function () { 
            /*
            {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            */
           
            let opcoes = [                        
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index' }, 
            ];

            return opcoes;
        }
    },

    methods: { 
        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\formaPagamento', 
              item.id_forma_pagamento
            );
        },

        bandeiras_ativas (lista) { 
            return lista.filter(item => this.viewMode == 'T' || ( item.por_unidade && item.por_unidade.fl_ativo ) );
        },

        ajustarParcelas (parcelas, idx, campo) { 
            if ( parseInt ( parcelas[idx].in_parcela_max ) < parseInt ( parcelas[idx].in_parcela_min ) ) { 
                if ( campo == 'max' ) { 
                    parcelas[idx].in_parcela_min = parseInt(parcelas[idx].in_parcela_max);
                } else { 
                    parcelas[idx].in_parcela_max = parseInt(parcelas[idx].in_parcela_min);
                }
            } 

            if ( idx > 0 ) { 
                if ( parcelas[idx - 1].in_parcela_max != parseInt(parcelas[idx].in_parcela_min) - 1 ) { 
                    parcelas[idx - 1].in_parcela_max = parseInt(parcelas[idx].in_parcela_min) - 1;
                    this.ajustarParcelas(parcelas, idx - 1, "max");
                }
            }

            if ( idx + 1 < parcelas.length ) { 
                if ( parcelas[idx + 1].in_parcela_min != parseInt(parcelas[idx].in_parcela_max) + 1 ) { 
                    parcelas[idx + 1].in_parcela_min = parseInt(parcelas[idx].in_parcela_max) + 1;
                    this.ajustarParcelas(parcelas, idx + 1, "min");
                }
            }

        },

        incluirForma () { 
            this.validate = false;

            this.edicao = { 
                id_forma_pagamento: null, 
                st_forma_pagamento: "",
                fl_repasse_devol: false, 
            };

            $('#modelFormaDePagamento').modal('show');
        },

        editarForma (forma) { 
            this.validate = false;
            this.edicao = _.cloneDeep(forma);

            $('#modelFormaDePagamento').modal('show');
        },

        incluirBandeira (forma) { 
            this.item = null; 
            this.validate = false;

            this.$nextTick (() => { 
                this.item = { 
                    id_bandeira_cartao: null, 
                    st_bandeira_cartao: "", 
                    ch_tipo: forma.search == 'PIX' ? 'P' : forma.forma_pagamento.tipo_cartao,
                    tipo_cartao_exibir: forma.search == 'PIX' ? 'PIX' : ( forma.forma_pagamento.tipo_cartao == 'C' ? 'Crédito' : 'Débito' ),
                    filtros: [], 
                    por_unidade: { 
                        id_bandeira_cartao_unidade: null,
                        id_bandeira_cartao: null, 
                        in_maximo_parcelas: 1,
                        fl_ativo: true,
                        dc_taxa: 0,
                        in_prazo_recebimento: null, 
                        bandeira_cartao_parcelas: [], 
                    } 
                }

                $("#edicaoModal").modal('show');
            });
        },
        atualizarBandeira () { 

            this.$util.atualizar (this, { 
                service: 'bandeira_cartaos',
                dados: this.item,
                modal: 'edicaoModal',
                reload: true, 
            });
        },
        incluirParcelaTaxa () { 
            if ( this.item.por_unidade.bandeira_cartao_parcelas.length ) { 
             
                this.item.por_unidade.bandeira_cartao_parcelas[
                        this.item.por_unidade.bandeira_cartao_parcelas.length - 1
                    ].in_parcela_max = 
                    this.item.por_unidade.bandeira_cartao_parcelas[
                        this.item.por_unidade.bandeira_cartao_parcelas.length - 1
                    ].in_parcela_min;

            }

            this.item.por_unidade.bandeira_cartao_parcelas.push({ 
                id_bandeira_cartao_parcela: null, 
                id_bandeira_cartao_unidade: this.item.por_unidade.id_bandeira_cartao_unidade,
                in_parcela_min: this.item.por_unidade.bandeira_cartao_parcelas.length ? 
                    parseInt(this.item.por_unidade.bandeira_cartao_parcelas[
                        this.item.por_unidade.bandeira_cartao_parcelas.length - 1
                    ].in_parcela_max) + 1 : 2,
                in_parcela_max: null, 
                dc_taxa: 0, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                id_pacote: null, 
                dc_valor: 0, 
                fl_ativo: true,
                fl_combo: true,
                procedimento: { 
                    id_procedimento: null, 
                    st_procedimento: "", 
                }
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'forma_pagamentos.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    },
                    configs: ['notafiscal-forma-pagamento', 'integracao-contself-url']
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                    if (res.data.configs_lista) {
                        this.notafiscalFormaPagamento = res.data.configs_lista['notafiscal-forma-pagamento'] == '1';
                        this.contself = ( res.data.configs_lista['integracao-contself-url'] != '' && res.data.configs_lista['integracao-contself-url'] != null );
                    }

                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.item = null;

            this.$nextTick(() => { 
                this.validate = false;
                this.item = _.cloneDeep(item);
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'forma_pagamentos',
                dados: { 
                    ...this.edicao
                },
                modal: 'modelFormaDePagamento',
                reload: true,
            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggleBandeira (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'bandeira_cartao_unidades.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                        incluir: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'forma_pagamentos.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Formas de Pagamento", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
